module.exports = __webpack_public_path__ + "static/media/cat-15.bc1602ea.jpg";